import butter from "../../../src/landingPage/utils/butter-client";
import { WebinarsVideo } from "../../../src/landingPage/views/Webinars/WebinarsVideo";
import { NextHead } from "../../../src/landingPage/layouts/LayoutComponents/NextHead";
import { webinar } from "../../../src/landingPage/datasets/webinars";

const WebinarVideoPage = ({ butterData, videoData, resolvedUrl }) => {
  return (
    <>
      <NextHead
        currentPath={resolvedUrl}
        title={`${videoData?.title && `${videoData?.title} - `}Webinars`}
        description="Provide your name and email to gain access to this webinar."
      />
      <WebinarsVideo butterData={butterData} videoData={videoData} webinarDataset={webinar} />
    </>
  );
};

export const getServerSideProps = async context => {
  const { resolvedUrl } = context;
  const { videoId } = context.params;
  const videoIdPart = videoId.slice(0, 20);
  try {
    const response = await butter.page.retrieve("*", "webinars");
    const butterData = response.data.data.fields;
    let videoData = null;
    let currentVideo = butterData?.webinars?.filter(
      webinar => webinar.video_actual === `https://cdn.buttercms.com/${videoIdPart}`,
    );

    if (currentVideo[0]) {
      videoData = currentVideo[0];
    } else {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        resolvedUrl,
        butterData: butterData,
        videoData: videoData,
        wrapper: "MarketingWrapper",
      },
    };
  } catch (e) {
    return {
      notFound: true,
    };
  }
};

export default WebinarVideoPage;
